const TOKEN_KEY = 'aac_admin_token';

export const setAdminToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

// fetch wrapper that attaches the admin token to every request
export const adminFetch = (url, options = {}) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
};
